import io from 'socket.io-client';

import { config } from '../config';
import { getUserStorage } from '../store/user/utils';

let socketConnection: any;

/**
 * Hàm đăng ký TOÀN BỘ listener nghiệp vụ (do store/socket/middleware truyền vào).
 *
 * Vì sao phải giữ lại: khi mất kết nối, bản cũ tạo một socket MỚI nhưng không ai đăng ký lại
 * listener cho nó — socket mới im lặng hoàn toàn. Cộng với `reconnectionAttempts: 10`, chỉ cần
 * mất mạng / máy ngủ / deploy lại chat service quá khoảng 40 giây là socket cũ bỏ cuộc vĩnh viễn:
 * trang không nhận new-instant-v2 / instant-reserve / new-price-quotes nữa, lịch TG ưu tiên đứng
 * im, tới lượt cũng không hiện nút VẬN HÀNH — phải F5 mới thấy.
 */
let registerSocketEvents: ((socket: any) => void) | null = null;
let reconnectTimeout: any = null;
let lifecycleRegistered = false;

function createSocketConnection() {
  const user = getUserStorage();
  const socket = io(`${config.socketServerUrl}?token=${user.token}&app=web`, {
    reconnection: true,
    reconnectionDelay: 500,
    // KHÔNG giới hạn số lần thử: mất mạng bao lâu cũng phải tự nối lại được. Bản cũ dừng sau 10
    // lần (~40 giây) rồi im luôn cho tới khi người dùng F5.
    reconnectionAttempts: Infinity,
    reconnectionDelayMax: 5000,
    transports: ['websocket'],
    upgrade: false,
  });

  // Dựng lại kết nối KÈM listener sau 5 giây. Socket cũ được đóng hẳn để không tích tụ kết nối
  // rác mỗi lần rớt mạng.
  const scheduleReconnect = (reason: string) => {
    console.log('socket', reason);
    clearTimeout(reconnectTimeout);
    reconnectTimeout = setTimeout(() => {
      initSocketConnection();
    }, 5000);
  };

  // 'disconnect' KHÔNG dựng lại kết nối: socket.io tự nối lại trên chính socket này và listener
  // vẫn còn nguyên. Chỉ can thiệp khi nó đã bỏ cuộc hoặc server chủ động chấm dứt.
  socket.on('reconnect_failed', () => scheduleReconnect('reconnect failed'));
  socket.on('terminated', () => scheduleReconnect('terminated'));
  socket.on('error', () => scheduleReconnect('error'));

  return socket;
}

function initSocketConnection() {
  if (socketConnection) {
    try {
      socketConnection.removeAllListeners();
      socketConnection.close();
    } catch (e) {
      console.log('close socket error', e);
    }
  }
  socketConnection = createSocketConnection();
  if (registerSocketEvents) {
    registerSocketEvents(socketConnection);
  }
  registerLifecycleListeners();
  return socketConnection;
}

/**
 * Có mạng trở lại / quay lại tab mà socket đang đứt thì nối lại NGAY, không chờ hết chu kỳ thử của
 * socket.io. Trình duyệt thường treo timer của tab ẩn nên máy ngủ dậy là rơi vào đúng cảnh này.
 */
function registerLifecycleListeners() {
  if (lifecycleRegistered || typeof window === 'undefined') {
    return;
  }
  lifecycleRegistered = true;

  const reconnectIfDead = () => {
    if (!socketConnection || socketConnection.connected) {
      return;
    }
    clearTimeout(reconnectTimeout);
    initSocketConnection();
  };

  window.addEventListener('online', reconnectIfDead);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) {
      reconnectIfDead();
    }
  });
}

/** Middleware gọi 1 lần lúc kết nối: giữ lại cách đăng ký listener cho MỌI lần dựng lại sau này. */
function setSocketEventRegister(register: (socket: any) => void) {
  registerSocketEvents = register;
}

function getSocketConnection() {
  return socketConnection || initSocketConnection();
}

export { getSocketConnection, setSocketEventRegister };
